'use client';
import { OrderProgressStage, OrderProgressStageStatus } from 'bff';
import { useTranslations } from 'i11n';
import { cn } from 'ui';
import {
  ORDER_PROGRESS_STAGE_ICON,
  ORDER_PROGRESS_STAGE_LABEL_KEY,
  ORDER_PROGRESS_STATUS_TONE,
  OrderProgressAudience,
  orderProgressStatusLabelKey,
} from '../constants/order-progress';

// order_workflow_state — an order's step in a table or inbox row. Reuses the
// SAME presentation tables as the detail stepper, and never relies on color alone.
export const OrderWorkflowCell = ({
  stage,
  status,
  audience,
  className,
}: {
  stage: OrderProgressStage;
  status: OrderProgressStageStatus;
  audience: OrderProgressAudience;
  className?: string;
}) => {
  const t = useTranslations('orders.progress');

  const Icon = ORDER_PROGRESS_STAGE_ICON[stage];
  const tone = ORDER_PROGRESS_STATUS_TONE[status];

  return (
    <div className={cn('flex items-center gap-2', className)}>
      <span
        aria-hidden
        className={cn(
          'flex size-8 shrink-0 items-center justify-center rounded-full border',
          tone.node,
        )}
      >
        <Icon className='size-4' />
      </span>
      <span className='flex min-w-0 flex-col leading-tight'>
        <span className='truncate text-[13px] font-medium'>
          {t(ORDER_PROGRESS_STAGE_LABEL_KEY[stage])}
        </span>
        <span className={cn('truncate text-xs', tone.label)}>
          {t(orderProgressStatusLabelKey(stage, status, audience))}
        </span>
      </span>
    </div>
  );
};
